

/// <reference path="FileURL.ts" />

// Generated class FileAttachment_ManagedObject

class FileAttachment_ManagedObject extends FileURL
{
}
